// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__m_d8F","name":"styles_name__1uHGR","phone":"styles_phone__fngaX"};